import { Phone } from "lucide-react";

export default function StickyCallBar() {
  return (
    <div
      data-testid="sticky-call-bar"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between gap-3 border-t border-ember/40 bg-ink/95 p-4 backdrop-blur-xl md:hidden"
    >
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ember">24/7 Dispatch</p>
        <p className="font-display text-lg font-bold uppercase leading-tight text-white">Need a tow now?</p>
      </div>
      <a
        href="tel:+13302014612"
        data-testid="sticky-call-button"
        className="flex items-center gap-2 bg-ember px-6 py-3 font-display text-base font-bold uppercase tracking-wider text-white"
      >
        <Phone className="h-4 w-4" />
        Call Now
      </a>
    </div>
  );
}
